import { render, staticRenderFns } from "./SprintBacklog.vue?vue&type=template&id=50bc0390&scoped=true"
import script from "./SprintBacklog.vue?vue&type=script&lang=js"
export * from "./SprintBacklog.vue?vue&type=script&lang=js"
import style0 from "./SprintBacklog.vue?vue&type=style&index=0&id=50bc0390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bc0390",
  null
  
)

export default component.exports